import React from "react";
import styles from "./FormField.module.css";

export default function FormField({
  label,
  children,
  hint,
  error,
  className = "",
}) {
  return (
    <div className={[styles.field, className].join(" ")}>
      {label ? <label className={styles.label}>{label}</label> : null}

      {children}

      {hint && !error ? (
        <div className={styles.hint}>{hint}</div>
      ) : null}

      {error ? (
        <div className={styles.error}>{error}</div>
      ) : null}
    </div>
  );
}